// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file logger/options.proto (package logger, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file logger/options.proto.
 */
export const file_logger_options: GenFile = /*@__PURE__*/
  fileDesc("ChRsb2dnZXIvb3B0aW9ucy5wcm90bxIGbG9nZ2VyKlcKC1NlbnNpdGl2aXR5EhsKF1NFTlNJVElWSVRZX1VOU1BFQ0lGSUVEEAASEwoPU0VOU0lUSVZJVFlfUElJEAESFgoSU0VOU0lUSVZJVFlfU0VDUkVUEAI6QwoNcmVkYWN0X2Zvcm1hdBIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYhgogASgJUgxyZWRhY3RGb3JtYXQ6MgoEbmFtZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYhwogASgJUgRuYW1lOlUKC3NlbnNpdGl2aXR5Eh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxiICiABKA4yEy5sb2dnZXIuU2Vuc2l0aXZpdHlSC3NlbnNpdGl2aXR5Qn4KCmNvbS5sb2dnZXJCDE9wdGlvbnNQcm90b1ABWipnaXRodWIuY29tL2xpdmVraXQvcHJvdG9jb2wvbGl2ZWtpdC9sb2dnZXKiAgNMWFiqAgZMb2dnZXLKAgZMb2dnZXLiAhJMb2dnZXJcR1BCTWV0YWRhdGHqAgZMb2dnZXJiBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * @generated from enum logger.Sensitivity
 */
export enum Sensitivity {
  /**
   * Unannotated default — safe to log.
   * Identifiers, IDs, timestamps, enums, status fields.
   *
   * @generated from enum value: SENSITIVITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * User-identifying or user-controlled data: display names, phone numbers,
   * metadata, attributes, custom headers, auth usernames, semi-public account
   * identifiers (AWS role ARNs, Azure account names).
   * Redacted by logger.Proto(); exposed by logger.UnredactedProto() for
   * operator-facing observability events.
   *
   * @generated from enum value: SENSITIVITY_PII = 1;
   */
  PII = 1,

  /**
   * Credentials and authentication material: passwords, access keys, session
   * tokens, signing keys, API keys, ICE credentials.
   * ALWAYS redacted, including by logger.UnredactedProto().
   *
   * @generated from enum value: SENSITIVITY_SECRET = 2;
   */
  SECRET = 2,
}

/**
 * Describes the enum logger.Sensitivity.
 */
export const SensitivitySchema: GenEnum<Sensitivity> = /*@__PURE__*/
  enumDesc(file_logger_options, 0);

/**
 * @generated from extension: string redact_format = 1286;
 */
export const redact_format: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_logger_options, 0);

/**
 * @generated from extension: string name = 1287;
 */
export const name: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_logger_options, 1);

/**
 * @generated from extension: logger.Sensitivity sensitivity = 1288;
 */
export const sensitivity: GenExtension<FieldOptions, Sensitivity> = /*@__PURE__*/
  extDesc(file_logger_options, 2);

